<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>It is unusual that adult life experiences that largely involved teaching at schools and a university would also include wanderings in the Australian outback and visits to a foundry. Nevertheless, these forays have informed this adventure story.</p>
<p>The author now enjoys wanderings with his wife Barbara. They live in the Bay of Islands, New Zealand where they enjoy gardening, orcharding and fishing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7fcbf68d